import React from "react";

export interface HelloWorldProps {
  testString: string;
  testNumber: number;
}

const HelloWorld: React.FC<HelloWorldProps> = ({ testString, testNumber }) => (
  <div data-testid={"hello-world-test"}>
    <p> Hello World.</p>
    <p>
      String value is: {testString}, Number value is: {testNumber}
    </p>
  </div>
);

export default HelloWorld;
